import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import { useMemo } from 'react';
import { BaseOption } from 'ui/selectv2/types';

export const useDashboardFilterOptions = () => {
  const {
    projectLabelsQuery: { results: labels },
    messageTypesQuery: { messageTypes },
  } = useMissionControlContext();

  const labelsOptions: BaseOption[] = useMemo(
    () =>
      labels.map(({ id, name }) => ({
        id,
        label: name as string,
        value: id?.toString(),
      })),
    [labels],
  );

  const messageTypesOptions: BaseOption[] = useMemo(
    () =>
      messageTypes?.map(({ id, name }) => ({
        id,
        label: name as string,
        value: id?.toString(),
      })),
    [messageTypes],
  );

  return {
    labelsOptions,
    messageTypesOptions,
  };
};
